import { render, staticRenderFns } from "./SopportunityIndex.vue?vue&type=template&id=5a0ba5cc"
import script from "./SopportunityIndex.vue?vue&type=script&lang=js"
export * from "./SopportunityIndex.vue?vue&type=script&lang=js"
import style0 from "./SopportunityIndex.vue?vue&type=style&index=0&id=5a0ba5cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports